export function getCardBackgroundColor(status) {
  switch (status) {
    case "Sold":
      return "rgb(129, 129, 129)";
    case "Reserved":
      return "rgb(159,248,159)";
    case "Unconditional":
      return "rgb(202,100,202)";
    case "Settled":
      return "rgb(202,100,202)";
    default:
      return "rgb(255, 255, 255)";
  }
}



// WEBPACK FOOTER //
// ./src/helpers/colorHelper.js